import { useEffect, useState } from "react";
import api from "../api/api";
import "../styles/environment.css"; // ensure file exists

export default function Environment() {
  const [data, setData] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("environment/");
        if (Array.isArray(res.data)) setData(res.data);
        else setData([]);
      } catch (err) {
        console.error("Environment API Error:", err);
        setData([]);
      }
    };
    fetchData();
  }, []);

  // ESC key + scroll lock
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setSelectedImage(null);
    };

    if (selectedImage) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [selectedImage]);

  return (
    <div className="environment-container">
      <h1 className="env-heading">Environment Activities</h1>

      {data.length === 0 && <p>No environment activities found.</p>}

      {data.map((item) => (
        <div key={item.id} className="env-card">
          <h3>{item?.title}</h3>
          <p>{item?.description}</p>

          <div className="env-image-grid">
            {item?.images?.map((img) => {
              if (!img?.image) return null;

              const imageUrl =
                typeof img.image === "string" && img.image.startsWith("http")
                  ? img.image
                  : `http://127.0.0.1:8000${img.image}`;

              return (
                <img
                  key={img.id}
                  src={imageUrl}
                  alt="environment"
                  className="env-image"
                  onClick={() => setSelectedImage(imageUrl)}
                />
              );
            })}
          </div>
        </div>
      ))}

      {/* Modal */}
      {selectedImage && (
        <div
          className="env-modal-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="env-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <span
              className="env-modal-close"
              onClick={() => setSelectedImage(null)}
            >
              
            </span>

            <img
              src={selectedImage}
              alt="popup"
              className="env-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}